import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';

const BASE_URL = `${OPAL_URL}/messaging-service/api/v1`;

type UnreadCountResponse = {
  count: number;
};

// Uses the count endpoint rather than the conversation list: that list is paged
// and resolves participant profiles, so it would go blind past the first page
// and do a lot of work for one boolean.
export async function fetchHasUnreadConversations(): Promise<boolean> {
  const res = await http.get<UnreadCountResponse>(`${BASE_URL}/conversations/unread-count`);
  return res.data.count > 0;
}
